// Backup for <s-variant-picker>: if that module never loads, picking a size or color would
// leave the form on the first variant. This keeps the hidden variant id in sync and reloads
// the page on the chosen variant (?variant= is read by the server) so price and stock match.
// It has no imports on purpose, so it still runs when other modules fail.
document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLElement)) return;
  const picker = input.closest('s-variant-picker');
  if (!picker) return;
  if (customElements.get('s-variant-picker')) return; // the real picker is handling it

  const variantId = input.dataset.variantId || input.selectedOptions?.[0]?.dataset?.variantId;
  if (!variantId) return;

  const form = picker.closest('form') || picker.closest('[data-product-form]')?.querySelector('form');
  const idInput = form?.querySelector('input[name="id"]');
  if (idInput) idInput.value = variantId;

  const url = new URL(window.location.href);
  url.searchParams.set('variant', variantId);
  window.location.replace(url.toString());
});
